/**
 * /platform/settings — settings for the platform operator (admin.system).
 * @file src/web/features/platform/pages/settings.tsx
 *
 * The platform console is deliberately separate from the CA-facing
 * /admin/settings (which carries professional/entity chrome — the professional profile, an
 * entity switcher, server-wide AppSettings). A platform operator has none of
 * that context, so they got the wrong sidebar when sent to /admin/settings.
 * This page gives them a home inside the platform shell; for now it hosts the
 * self-service Change password card, and is the place to add operator-level
 * settings later.
 */

import { SEO } from '../../../shared/components';
import { AdminPageHeader } from '../../admin/components/AdminPageHeader';
import { ChangePasswordCard } from '../../admin/components/ChangePasswordCard';

export default function PlatformSettingsPage() {
  return (
    <>
      <SEO title="Settings" />
      <AdminPageHeader title="Settings" breadcrumbs={[{ label: 'Platform' }, { label: 'Settings' }]} />
      <div className="space-y-6">
        <ChangePasswordCard />
      </div>
    </>
  );
}
